
import { Component, Prop, Vue } from 'vue-property-decorator';
import InternalTicketsRepositoryInterface from '@/services/Internal-Tickets/interfaces';
import CommentEntity from '@/services/Internal-Tickets/interfaces/comment.entity';

@Component({
  inject: ['internalTicketsRepository'],
})
export default class CommentComponent extends Vue {

  @Prop() ticketId: string;
  @Prop() isVisible: boolean;

  public comments: CommentEntity[] = [];
  public commentsExist: boolean = false;
  public commentsPopupVisible: boolean = false;
  public commentInput: string = '';

  private readonly internalTicketsRepository: InternalTicketsRepositoryInterface;

  async mounted() {
    this.comments = await this.internalTicketsRepository.getCommentsByTicketId(this.ticketId);
    if(this.comments.length > 0) {
      this.commentsExist = true;
    }
  }

  public async addComment() {
    await this.internalTicketsRepository.createComment(Number(this.ticketId), { message: this.commentInput });
    this.commentInput = '';
  }

  public async viewComments() {
    this.comments = await this.internalTicketsRepository.getCommentsByTicketId(this.ticketId);
    this.commentsPopupVisible = true;
  }

  public closeCommentsPopup() {
    this.commentsPopupVisible = false;
  }
}
